<template>
  <v-card>
    <v-card-title class="subtitle-1 d-flex justify-space-between">
      <span>{{ $t('dealer.dashboard.recentOrders') }}</span>
      <router-link :to="{ name: 'DealerOrders' }">
        {{ $t('dealer.dashboard.viewAll') }}
      </router-link>
    </v-card-title>
    <v-list>
      <v-list-item
        v-for="order in orders"
        :key="order.id"
        :to="{ name: 'DealerOrderDetail', params: { id: order.id } }"
      >
        <v-list-item-content>
          <v-list-item-title>
            {{ order.code }}
            <span class="grey--text text--darken-1 ml-2">
              {{ order.customer.firstName }} {{ order.customer.lastName }}
              <template v-if="order.shippingAddress && order.shippingAddress.city">
                &mdash; {{ order.shippingAddress.city }}
              </template>
            </span>
          </v-list-item-title>
        </v-list-item-content>
        <v-list-item-action class="flex-row align-center">
          <v-chip
            small
            :color="stateColor(order.state)"
            :text-color="order.state === 'Completato' ? 'white' : undefined"
            :style="order.state === 'Completato' ? { backgroundColor: '#6a1b9a' } : {}"
            class="mr-3"
          >
            {{ $t(`dealer.states.${order.state}`) }}
          </v-chip>
          <span class="font-weight-medium">{{ formatCurrency(order.total) }}</span>
        </v-list-item-action>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>
import { formatCurrency } from '@/store/modules/dealerOrders';

export default {
  name: 'DealerRecentOrders',

  props: {
    orders: {
      type: Array,
      default: () => [],
    },
  },

  methods: {
    formatCurrency,

    stateColor(state) {
      const map = {
        Nuovo: 'primary',
        InElaborazione: 'warning',
        Spedito: 'success',
        Completato: 'purple',
      };
      return map[state] || 'grey';
    },
  },
};
</script>
